"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitNewWorkspaceLogoF = void 0;
var tslib_1 = require("tslib");
var createErrorAction_1 = require("./../../../actionCreators/createErrorAction");
var effects_1 = require("redux-saga/effects");
var selectState_1 = require("../../../state/selectState");
var storage_1 = require("firebase/storage");
var createId_1 = require("../../../utilities/create/createId");
var getWorkspaceLogoStoragePath_1 = require("../../../utilities/get/getWorkspaceLogoStoragePath");
var uploadSuccessWorkspaceLogoSaga_1 = require("../../sagas/uploadSuccess/uploadSuccessWorkspaceLogoSaga");
var takeGaurd_1 = require("../../../utilities/takeGaurd");
var storage_2 = require("firebase/storage");
var description = 'submitNewWorkspaceLogoF';
var submitNewWorkspaceLogoF = function () {
    var action, file, state, workspaceId, ratio, uploadId, storageRef, originalPath, uploadRef, uploadMeta, error_1;
    var _a;
    var _b;
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!1) return [3 /*break*/, 13];
                return [4 /*yield*/, (0, takeGaurd_1.takeGaurd)('SUBMIT_WORKSPACE_LOGO_ACTION')];
            case 1:
                action = _c.sent();
                file = action.fileBlob || ((_b = action.files) === null || _b === void 0 ? void 0 : _b[0]);
                return [4 /*yield*/, (0, effects_1.select)(selectState_1.selectState)];
            case 2:
                state = _c.sent();
                workspaceId = state.currentWorkspaceId;
                ratio = action.ratio;
                if (!(file && workspaceId)) return [3 /*break*/, 9];
                _c.label = 3;
            case 3:
                _c.trys.push([3, 6, , 8]);
                uploadId = (0, createId_1.createId)();
                storageRef = (0, storage_2.ref)((0, storage_1.getStorage)());
                originalPath = (0, getWorkspaceLogoStoragePath_1.getWorkspaceLogoStoragePath)({ workspaceId: workspaceId }).originalPath;
                uploadRef = (0, storage_2.ref)(storageRef, originalPath);
                uploadMeta = {};
                return [4 /*yield*/, (0, effects_1.put)({
                        type: 'UPLOAD_REQUEST',
                        description: 'submitNewWorkspaceLogoF',
                        requestValues: (_a = {},
                            _a[uploadId] = {
                                data: file,
                                ref: uploadRef,
                                meta: uploadMeta,
                                status: 'uploading',
                            },
                            _a),
                    })];
            case 4:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.spawn)(uploadSuccessWorkspaceLogoSaga_1.uploadSuccessWorkspaceLogoSaga, {
                        uploadId: uploadId,
                        workspaceId: workspaceId,
                        ratio: ratio,
                    })];
            case 5:
                _c.sent();
                return [3 /*break*/, 8];
            case 6:
                error_1 = _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, createErrorAction_1.createErrorAction)({
                        error: error_1,
                        description: description,
                    }))];
            case 7:
                _c.sent();
                return [3 /*break*/, 8];
            case 8: return [3 /*break*/, 11];
            case 9: return [4 /*yield*/, (0, effects_1.put)((0, createErrorAction_1.createErrorAction)({
                    description: description,
                }))];
            case 10:
                _c.sent();
                _c.label = 11;
            case 11: 
            // TODO: move all the submit done to the end
            return [4 /*yield*/, (0, effects_1.put)({
                    type: 'SUBMIT_WORKSPACE_LOGO_ACTION_DONE',
                    description: description,
                })];
            case 12:
                // TODO: move all the submit done to the end
                _c.sent();
                return [3 /*break*/, 0];
            case 13: return [2 /*return*/];
        }
    });
};
exports.submitNewWorkspaceLogoF = submitNewWorkspaceLogoF;
